/** Перенос `domain/models/api_response_model/api_response_status.dart`. */

import { z } from 'zod';

/**
 * В Dart это `enum` с `@JsonValue`, совпадающим с именем участника, поэтому
 * значением перечисления в порте служит сама строка из JSON.
 */
export const ApiResponseStatus = {
  success: 'success',
  error: 'error',
} as const;

export type ApiResponseStatus = (typeof ApiResponseStatus)[keyof typeof ApiResponseStatus];

/** `ApiResponseStatus.values` — порядок как в Dart-перечислении. */
export const API_RESPONSE_STATUS_VALUES: readonly ApiResponseStatus[] = [
  ApiResponseStatus.success,
  ApiResponseStatus.error,
];

export const apiResponseStatusSchema = z.enum([
  ApiResponseStatus.success,
  ApiResponseStatus.error,
]);

/**
 * `ApiResponseStatus.fromString`. В Dart это `firstWhere` без `orElse` —
 * на неизвестном значении он бросал `StateError`; здесь бросает `ZodError`.
 * И то и другое слой исключений превращает в `badContract`.
 */
export function apiResponseStatusFromString(value: unknown): ApiResponseStatus {
  return apiResponseStatusSchema.parse(value);
}
